// extracted by mini-css-extract-plugin
module.exports = {"container":"VideosCard_container__3klDA","vid":"VideosCard_vid__1Xb0g","title":"VideosCard_title__tKx1c","vidCont":"VideosCard_vidCont__38ZZa","play":"VideosCard_play__1Ndvz"};